import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Box, Button, CircularProgress, Container, FormControl, InputLabel, MenuItem, Select, Table, TableBody, TableCell, TableHead, TableRow, TextField, Typography } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid'; 
import PageHeader from '../../../components/common/PageHeader';

export default function ImportMegToPipedriveBDC() {
  const [file, setFile] = useState(null);
  const [pipeline, setPipeline] = useState('');
  const [pipelineList, setPipelineList] = useState([]);
  const [user, setUser] = useState('');
  const [userList, setUserList] = useState([]);
  const [resultImport, setResultImport] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchPipelines = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_API_URL}/api/pipedrive/pipelines`
      );
      console.log(res.data)
      setPipelineList(res.data);
    } catch (err) {
      console.error('❌ Erreur lors de la récupération des pipelines :', err);
    }
  };

  const fetchUsers = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_API_URL}/api/pipedrive/users`
      );
      console.log(res.data)
      const filteredUsers = res.data.filter(user => user.active_flag === true);
      setUserList(filteredUsers);
    } catch (err) {
      console.error('❌ Erreur lors de la récupération des utilisateurs :', err);
    }
  };

  useEffect(() => {
    fetchPipelines();
    fetchUsers();
  }, []);

  const handleUpload = async () => {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('pipeline', pipeline);
    formData.append('user', user);

    try {
      setLoading(true)
      const res = await axios.post(
        `${process.env.REACT_APP_API_URL}/api/import/import-bdc-meg-pipedrive`,
        formData,
        {
          headers: { 'Content-Type': 'multipart/form-data' },
        }
      );
      setResultImport(res.data.results);
      setLoading(false)
      console.log('✔️ Import réussi :', res.data);
    } catch (err) {
      console.error('❌ Erreur import :', err);
    }
  };

  return (
    <Box>
      <Box>
        <PageHeader section="Imports" title="Importation BDC" />
      </Box>
      <Box
        sx={{
          width: {
            xs: '100%',
            sm: '100%',
            md: '100%',
            lg: '50%',
            xl: '50%',
          },
        }}
      >
        <Box component={'form'} onSubmit={e => {
          e.preventDefault()
          handleUpload();
        }}>
          <FormControl sx={{my:2}} component={'form'} fullWidth>
            <InputLabel>Pipeline</InputLabel>
            <Select
              value={pipeline}
              label="Pipeline"
              onChange={e => setPipeline(e.target.value)}
              required
            >
              <MenuItem value="" disabled>
                Sélectionner une pipeline
              </MenuItem>
              {pipelineList.length !== 0 &&
                pipelineList.map(p => (
                  <MenuItem key={p.id} value={p.name}>
                    {p.name}
                  </MenuItem>
                ))}
            </Select>
          </FormControl>
          <FormControl sx={{my:2}} fullWidth>
            <InputLabel>Utilisateur propriétaire</InputLabel>
            <Select
              value={user}
              label="Utilisateur propriétaire"
              onChange={e => setUser(e.target.value)}
              required
            >
              <MenuItem value="" disabled>
                Sélectionner un utilisateur
              </MenuItem>
              {userList.length !== 0 &&
                userList.map(p => (
                  <MenuItem key={p.id} value={p.name}>
                    {p.name}
                  </MenuItem>
                ))}
            </Select>
          </FormControl>
          <TextField
            type="file"
            accept=".xls"
            onChange={e => setFile(e.target.files[0])}
            required
            fullWidth
          />
          <Button type="submit" variant="contained" sx={{ my: 2, }} fullWidth>
            Importer
          </Button>
        </Box>
      {loading && (
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', mt: 2 }}>
          <Typography variant="body2" mr={2}>Import en cours...</Typography>
          <CircularProgress />
        </Box>
      )}
      <Box>
        {resultImport.length > 0 && (
          <Box sx={{ mt: 2, height: 400, width: '100%' }}>
            <DataGrid
              rows={resultImport.map((result, index) => ({
                id: index,
                dealName: result.dealName,
                status:
                result.status === "updated"
                ? "Mise à jour"
                : result.status === "created"
                ? "Création"
                : result.status,
              }))}
              columns={[
                { field: 'dealName', headerName: 'Deal Name', flex: 2 },
                { field: 'status', headerName: 'Status', flex: 1 },
              ]}
              pageSize={5}
              rowsPerPageOptions={[5, 10, 25]}
              disableSelectionOnClick
              />
          </Box>
        )}
        </Box>
      </Box>
    </Box>
  );
}
